<ui-section class="platform-admin-tabs">
  <ui-block width="fill">
    <ui-tab-group [attr.aria-description]="isAdminDraftNavigationBlocked() ? 'Save or close an open draft, or wait for the current administration action to finish before switching Platform Admin sections.' : null" [tabConfig]="tabs"></ui-tab-group>
  </ui-block>
</ui-section>
